export interface IInputField {
    value: string;
    hasError: boolean;
    isOpen: boolean;
}

export enum CountryCombination {
    US,
    Canada,
    USOrCanada
}